import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-webhook-options',
  templateUrl: './webhook-options.component.html',
  styleUrls: ['./webhook-options.component.scss']
})
export class WebhookOptionsComponent implements OnInit {
  @Output() validWebhook: EventEmitter<string>;
  webhook_url: string;
  test_webhook_message: string;
  validWebhookUrl: boolean;
  validWebhookMessage: boolean;
  spinning: boolean;
  spinningTestMessage: boolean;
  testedWebhookUrl: boolean;
  testedWebhookMessage: boolean;
  testWebhookPublicMessages = [];
  testWebhookPrivateMessages = [];
  testWebhookReactions = [];

  constructor(private httpClient: HttpClient) {
    this.validWebhook = new EventEmitter();
    this.test_webhook_message = '';
    this.webhook_url = '';
    this.validWebhookUrl = false;
    this.validWebhookMessage = false;
    this.testedWebhookUrl = false;
    this.testedWebhookMessage = false;
    this.spinning = false;
    this.spinningTestMessage = false;
  }
  ngOnInit() {}

  setWebhookUrl(url: string) {
    this.testedWebhookUrl = false;
    this.validWebhookUrl = false;
    this.testedWebhookMessage = false;
    this.validWebhookMessage = false;
    this.webhook_url = url;
    this.validWebhook.emit();
  }

  setTestWebhookMessage(message: string) {
    this.test_webhook_message = message;
    this.testedWebhookMessage = false;
    this.validWebhookMessage = false;
  }

  testWebhookUrl() {
    this.spinning = true;
    this.httpClient
      .post(
        this.webhook_url,
        {
          comment: 'This is a test!'
        },
        { responseType: 'json' }
      )
      .subscribe(
        data => {
          if (data) {
            this.spinning = false;
            this.testedWebhookUrl = true;
            this.validWebhookUrl = true;
            this.validWebhook.emit(this.webhook_url);
          }
        },
        error => {
          console.error('POST request failed:', error);
          this.spinning = false;
          this.testedWebhookUrl = true;
          this.validWebhookUrl = false;
          this.validWebhook.emit();
        }
      );
  }

  sendTestWebhookMessage() {
    this.spinningTestMessage = true;
    this.testWebhookPrivateMessages = [];
    this.testWebhookPublicMessages = [];
    this.testWebhookReactions = [];

    this.httpClient
      .post(
        this.webhook_url,
        {
          comment: this.test_webhook_message
        },
        { responseType: 'json' }
      )
      .subscribe(
        data => {
          if (typeof data['publicMessages'] === 'string') {
            this.testWebhookPublicMessages.push(data['publicMessages']);
          } else if (Array.isArray(data['publicMessages']) && data['publicMessages'].every(item => typeof item === 'string')) {
            this.testWebhookPublicMessages = data['publicMessages'];
          }

          if (typeof data['privateMessages'] === 'string') {
            this.testWebhookPrivateMessages.push(data['privateMessages']);
          } else if (Array.isArray(data['privateMessages']) && data['privateMessages'].every(item => typeof item === 'string')) {
            this.testWebhookPrivateMessages = data['privateMessages'];
          }
          if (typeof data['reactions'] === 'string') {
            this.testWebhookReactions.push(data['reactions']);
          } else if (Array.isArray(data['reactions']) && data['reactions'].every(item => typeof item === 'string')) {
            this.testWebhookReactions = data['reactions'];
          }

          this.spinningTestMessage = false;
          this.testedWebhookMessage = true;
          this.validWebhookMessage = true;
          this.validWebhook.emit(this.webhook_url);
        },
        error => {
          console.error('POST request failed:', error);
          this.spinningTestMessage = false;
          this.testedWebhookMessage = true;
          this.validWebhookMessage = false;
          this.validWebhook.emit();
        }
      );
  }
}
